<template>
  <div class="about-page">
    <div class="content-wrapper">
      <h1>关于我</h1>
      <p class="intro">
        欢迎来到我的网站，我是一个热衷于技术和创新的开发者。
      </p>
      <section class="section-block">
        <h2>我的愿景</h2>
        <p>
          致力于创造直观、高效且美观的用户体验。我相信技术的力量可以连接世界，让生活更美好。
        </p>
      </section>
      <section class="section-block">
        <h2>我的技能</h2>
        <ul class="skill-list">
          <li>前端开发：Vue.js, React, JavaScript, TypeScript, HTML, CSS (SCSS)</li>
          <li>后端开发：Node.js, Python, Java</li>
          <li>数据库：MongoDB, PostgreSQL, MySQL</li>
          <li>工具：Git, Webpack, Docker</li>
        </ul>
      </section>
      <section class="section-block">
        <h2>联系方式</h2>
        <p>
          如果您有任何项目合作或只是想聊聊技术，随时欢迎与我联系！
        </p>
        <a href="mailto:shiqing_chen@qq.com" class="contact-link">发送邮件给我</a>
      </section>
      <router-link to="/" class="back-home">返回首页</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
  created() {
    // 获取当前网站的基础标题，并在其前面追加“关于我 - ”
    document.title = '关于我 - ' + document.title; 
  }
}
</script>

<style lang="scss" scoped>
.about-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%); /* 与首页hero区颜色反向 */
  color: white;
  padding: 2rem 1rem;
  text-align: center;
}

.content-wrapper {
  max-width: 800px;
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 2rem;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  
  @media (max-width: 768px) {
    padding: 1.5rem;
  }
}

h1 {
  font-size: clamp(2.5rem, 6vw, 4rem);
  margin-bottom: 1.5rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.intro {
  font-size: clamp(1rem, 3vw, 1.2rem);
  margin-bottom: 2rem;
  opacity: 0.9;
}

.section-block {
  margin-bottom: 2.5rem;
  text-align: left;
  padding: 0 1rem; // 稍微内缩内容

  h2 {
    font-size: clamp(1.5rem, 4vw, 2rem);
    margin-bottom: 1rem;
    color: #f8f9fa;
    text-align: center;
  }

  p {
    font-size: clamp(0.9rem, 2.5vw, 1rem);
    line-height: 1.7;
    margin-bottom: 1rem;
    opacity: 0.8;
  }
}

.skill-list {
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 1.5rem;

  li {
    background: rgba(255, 255, 255, 0.15);
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.85rem;
    border: 1px solid rgba(255, 255, 255, 0.2);
    white-space: nowrap; // 防止技能标签换行
  }
}

.contact {
  p {
    margin-bottom: 1rem;
  }
}

.contact-link, .back-home {
  display: inline-block;
  padding: 0.8em 2em;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  text-decoration: none;
  border-radius: 25px;
  font-size: clamp(0.9rem, 3vw, 1.1rem);
  transition: all 0.3s ease;
  border: 2px solid rgba(255, 255, 255, 0.3);
  margin-top: 2rem;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
  }
  &:active {
    transform: translateY(0);
  }
}

.contact-link {
  margin-top: 1.5rem;
}

.back-home {
  margin-top: 2.5rem;
  background: none;
  border: 2px solid rgba(255, 255, 255, 0.4);
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

// 暗色模式适配
@media (prefers-color-scheme: dark) {
  .about-page {
    background: linear-gradient(135deg, #000000 0%, #434343 100%);
  }
  .content-wrapper {
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.05);
  }
  .section-block {
    h2 {
      color: #eee;
    }
  }
  .skill-list li {
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  .contact-link, .back-home {
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.2);
    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }
  }
  .back-home {
    background: none;
    &:hover {
      background: rgba(255, 255, 255, 0.05);
    }
  }
}
</style> 